/* ============================================================
   Titelvideo: erst laufen lassen, danach am Scrollen haengen.

   Die Datei traegt 720 Bilder mit 60 je Sekunde, jedes zweite des
   120-fps-Renders vom 09.09. Die Zahlen unten bleiben QUELLBILDER in der
   Zaehlung des urspruenglichen 360er-Renders (Halt bei 210 usw.); die
   Umrechnung auf das Dateibild macht dateibild(). Warum 720 und nicht
   alle 1440: bei 60 Hz bekommt jeder Bildschirmtakt ein neues Bild, solange
   schneller als 147 px/s gescrollt wird, das decken 720; die 1440 helfen
   nur unter 74 px/s und kosten die doppelte Datei.

     Quellbild 200  ab hier wird gebremst   ~6,66 s
     Quellbild 210  Halt nach dem Vorlauf   ~6,99 s
     Quellbild 170  weiteste Ruecklage      ~5,66 s
     Quellbild 360  Ende, wenn die Section unter dem Titel den Kopf
                    beruehrt                ~11,99 s

   Jedes Bild der Datei ist ein I-Bild, deshalb ist das Spulen exakt.
   ============================================================ */
(function () {
  "use strict";

  var QUELLBILDER = 360;   // gerenderte Bilder
  var DATEIBILDER = 720;   // Bilder in der Datei
  var FPS         = 60;

  var HALT   = 210;        // hier steht das Video nach dem Vorlauf
  var BREMSE = 200;        // ab hier laeuft es aus statt abrupt zu halten
  var TIEF   = 170;        // weiter zurueck geht es beim Hochscrollen nicht
  var ENDE   = 360;        // hier steht es, wenn die naechste Section den Kopf beruehrt
  var WEG    = 0.5;        // nur noch Rueckfall, falls die Marke danach fehlt

  var video = document.getElementById("orbitvideo");
  var kasten = document.getElementById("orbit");
  var hud = document.getElementById("hud");
  var schalter = document.getElementById("hudschalter");
  /* Im Prototyp tragen die beiden eigene Kennungen, im Theme nicht.
     Dort ist es die erste Section nach dem Titel und die klebende Kopfzeile. */
  var danach = document.getElementById("danach") || document.querySelector(".v-hero ~ section");
  var kopf = document.getElementById("kopf") || document.querySelector(".v-nav");

  if (!video || !kasten) return;   // Vorlage ohne Titelvideo

  /* Zwei Dateien, eine Wahl vor dem ersten Byte. Die grosse (1920 breit)
     nur dort, wo die kleine (1280) hochskaliert wuerde: gemessen wird die
     Breite des Videokastens in Geraetepixeln, nicht die Fensterbreite und
     nicht eine Geraeteklasse. Ein Telefon mit 375 x 3 = 1125 bekommt die
     kleine, ein Tablet mit 800 x 2 = 1600 die grosse, ein 1x-Monitor mit
     864 breitem Kasten wieder die kleine. Das Markup traegt deshalb keine
     source-Zeile: stuende sie dort, laedt der Browser sie schon, bevor
     dieses Skript laeuft, und die Wahl kaeme zu spaet. Ohne die beiden
     data-Attribute (Prototyp) bleibt alles wie es ist. */
  var gross = video.getAttribute("data-src-gross");
  var klein = video.getAttribute("data-src-klein");
  if (gross && klein && !video.getAttribute("src")) {
    var breite = kasten.getBoundingClientRect().width * (window.devicePixelRatio || 1);
    video.src = breite > 1280 ? gross : klein;
    video.setAttribute("data-quelle", breite > 1280 ? "gross" : "klein");
  }

  var ruhig = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ?sofort=1 ueberspringt den Vorlauf und setzt gleich auf Bild 180.
     Nur zum Pruefen der Scroll-Mechanik, in der Section faellt das weg. */
  var sofort = /(?:\?|&)sofort=1(?:&|$)/.test(location.search);

  /* Quellbild -> Bild der Datei -> Zeitpunkt in der Mitte dieses Bildes.
     Die halbe Bilddauer Zuschlag sorgt dafuer, dass der Browser sicher
     das gemeinte Bild zeigt und nicht das davor. */
  function dateibild(q) {
    var i = Math.round(q / (QUELLBILDER / DATEIBILDER)) - 1;
    return Math.max(0, Math.min(DATEIBILDER - 1, i));
  }
  function zeit(q) { return (dateibild(q) + 0.5) / FPS; }

  /* Wie lange das Auslaufen von BREMSE bis HALT dauern muss, damit es an
     beiden Enden nicht ruckt. Die Kurve unten ist 1-(1-u)^3, ihre
     Anfangssteigung ist 3. Damit die gleich der Abspielgeschwindigkeit
     ist, muss die Dauer 3 * Strecke / Quellbilder-je-Sekunde sein. */
  function proSekunde() { return QUELLBILDER / (video.duration || 12); }

  function bremsdauer() {
    return 3 * (HALT - BREMSE) / proSekunde() * 1000;
  }

  /* Anteil des Videos, der nicht mehr im Fenster steht. 0 = ganz zu sehen.
     Nur fuer den Ableser, gesteuert wird ueber fortschritt(). */
  function verdeckt() {
    var r = kasten.getBoundingClientRect();
    if (!r.height) return 0;
    var h = window.innerHeight || document.documentElement.clientHeight;
    var sichtbar = Math.max(0, Math.min(r.bottom, h) - Math.max(r.top, 0));
    return 1 - sichtbar / r.height;
  }

  function scrollstand() { return window.scrollY || window.pageYOffset || 0; }

  /* 0 am Seitenanfang, 1 sobald die Section unter dem Titel die
     Kopfzeile beruehrt. Dazwischen laeuft es gleichmaessig.

     Nicht der Verdeckungsgrad des Videos: solange das Video ganz im
     Fenster steht, waere der exakt 0, die ersten Hundert Pixel Scrollen
     taeten also nichts und danach spraenge das Video weiter, waehrend es
     gerade aus dem Bild rutscht.

     Gemessen wird in Dokumentkoordinaten. Die Kopfzeile klebt oben, also
     ist der Endpunkt der Scrollstand, bei dem die Oberkante der Section
     genau um die Kopfhoehe unter dem Fensterrand steht. */
  function endpunkt() {
    var y = scrollstand();
    if (danach) {
      var s = danach.getBoundingClientRect();
      var h = kopf ? kopf.getBoundingClientRect().height : 0;
      return (s.top + y) - h;
    }
    var r = kasten.getBoundingClientRect();   // Rueckfall: Video halb weg
    return (r.top + y) + r.height * WEG;
  }

  function fortschritt() {
    var ende = endpunkt();
    if (!(ende > 0)) return 1;
    return Math.max(0, Math.min(1, scrollstand() / ende));
  }

  var phase = "warten";        // warten, vorlauf, bremsen, scrollen
  var ist = 0;             // aktuelle Lage, gleitend
  var rueckzug = 0;        // 0..1, wieviel vom Weg 180 -> 170 genommen ist
  var seitStoss = 999;     // Takte seit dem letzten Schub nach oben
  var HALTEN = 20;         // so lange bleibt der Rueckzug stehen, dann federt er
  var letztes = -1;

  function ziel() {
    var p = fortschritt();
    if (p > 0) { rueckzug = 0; return HALT + p * (ENDE - HALT); }
    return HALT - rueckzug * (HALT - TIEF);
  }

  function spulen(q) {
    var b = dateibild(q);
    if (b === letztes || video.seeking) return;
    letztes = b;
    try { video.currentTime = zeit(q); } catch (e) { letztes = -1; }
  }

  function ableser(z) {
    if (!hud || hud.classList.contains("aus")) return;
    hud.innerHTML =
      "Quellbild <b>" + Math.round(ist) + "</b> / " + ENDE +
      "\nDateibild <b>" + dateibild(ist) + "</b> / " + (DATEIBILDER - 1) +
      "\nZeit      <b>" + video.currentTime.toFixed(2) + "</b> s" +
      "\nverdeckt  <b>" + Math.round(verdeckt() * 100) + "</b> %" +
      "\nWeg       <b>" + Math.round(fortschritt() * 100) + "</b> %" +
      "\nZiel      <b>" + Math.round(z) + "</b>" +
      "\nPhase     <b>" + phase + "</b>";
  }

  /* --- Vorlauf ------------------------------------------------
     Das Video wird nicht abgespielt, sondern Bild fuer Bild gesetzt,
     genauso wie beim Auslaufen und beim Scrollen. Abspielen haengt an
     der Autoplay-Erlaubnis des Browsers und faellt in einem Rahmen
     oder bei strengen Einstellungen still aus, ohne Fehler zu melden.
     Spulen braucht keine Erlaubnis. Die Datei besteht ausserdem nur
     aus I-Bildern, deshalb kostet das Setzen kaum mehr als Abspielen. */
  function vorlauf() {
    if (phase !== "warten") return;   // schon unterwegs, zweiter Anstoss ist wirkungslos
    if (ruhig || sofort) { ist = HALT; letztes = -1; phase = "scrollen"; return; }
    laufAb = 0;                  // den Zeitpunkt setzt der erste Takt
    phase = "vorlauf";
  }

  /* --- Hochscrollen am oberen Rand zieht bis Quellbild 170 ---- */
  window.addEventListener("wheel", function (e) {
    if (phase !== "scrollen") return;
    if (e.deltaY < 0 && scrollstand() <= 0) {
      rueckzug = Math.min(1, rueckzug + (-e.deltaY) / 500);
      seitStoss = 0;
    }
  }, { passive: true });

  var tippAn = 0;
  window.addEventListener("touchstart", function (e) { tippAn = e.touches[0].clientY; }, { passive: true });
  window.addEventListener("touchmove", function (e) {
    if (phase !== "scrollen") return;
    var d = e.touches[0].clientY - tippAn;
    tippAn = e.touches[0].clientY;
    if (d > 0 && scrollstand() <= 0) { rueckzug = Math.min(1, rueckzug + d / 320); seitStoss = 0; }
  }, { passive: true });

  /* --- Schleife ---------------------------------------------- */
  var laufAb = 0;          // Zeitstempel, an dem der Vorlauf begann
  var bremsAb = 0;         // Zeitstempel, an dem das Auslaufen begann
  var bremsDauer = 0;      // ms, aus bremsdauer()

  /* Das Ende des Titelvideos einmal melden: wenn der Scrollweg des Videos
     ganz zurueckgelegt ist (dasselbe Mass, das Quellbild 360 setzt). Das
     Newsletter-Popup wartet darauf. Unabhaengig von der Phase, damit auch
     ein Video, das nie geladen hat, nach dem Wegscrollen als vorbei gilt. */
  var endeGemeldet = false;
  function schritt(t) {
    if (!endeGemeldet && fortschritt() >= 0.999) {
      endeGemeldet = true;
      window.vioTitelvideoEnde = true;
      try { window.dispatchEvent(new CustomEvent("vio:titelvideo-ende")); } catch (e) {}
    }
    if (phase === "warten") {
      ableser(HALT);

    } else if (phase === "vorlauf") {
      /* Die Uhr laeuft erst los, wenn das erste Spulen angekommen ist.
         Eine Flaeche, die Spulbefehle verwirft, verbraucht so nicht den
         Vorlauf im Verborgenen, und eine, die sie annimmt, faengt sofort
         an. Auf visibilityState ist dabei kein Verlass: dieses Feld
         meldet in eingebetteten Ansichten dauerhaft "hidden", obwohl
         Spulen und requestAnimationFrame dort einwandfrei laufen. */
      if (!laufAb) {
        spulen(0);
        if (video.currentTime > 0) laufAb = t;
        ableser(HALT);
      } else {
        ist = Math.min(BREMSE, ((t - laufAb) / 1000) * proSekunde());
        spulen(ist);
        ableser(HALT);
        if (ist >= BREMSE) { phase = "bremsen"; bremsAb = t; bremsDauer = bremsdauer(); }
      }

    } else if (phase === "bremsen") {
      /* Von BREMSE nach HALT mit auslaufender Geschwindigkeit: bei BREMSE
         genau so schnell wie das laufende Video, bei HALT auf null. Ohne
         das bliebe das Video mitten in der Bewegung stehen. */
      var u = bremsDauer > 0 ? Math.min(1, (t - bremsAb) / bremsDauer) : 1;
      ist = BREMSE + (HALT - BREMSE) * (1 - Math.pow(1 - u, 3));
      spulen(ist);
      ableser(HALT);
      /* Wer waehrend des Auslaufens schon scrollt, bekommt sofort das
         Scrollen, sonst spraenge das Video am Ende der Bremse. */
      if (u >= 1 || fortschritt() > 0.01) phase = "scrollen";

    } else if (phase === "scrollen") {
      var z = ziel();
      ist += (z - ist) * 0.16;
      if (Math.abs(z - ist) < 0.05) ist = z;
      spulen(ist);
      /* Solange nach oben gescrollt wird, bleibt der Rueckzug stehen, damit
         die Glaettung Quellbild 170 auch wirklich erreicht. Erst wenn der
         Schub aufhoert, federt er zurueck auf 180. */
      if (scrollstand() <= 0) { if (++seitStoss > HALTEN) rueckzug *= 0.93; }
      else { seitStoss = 999; rueckzug = 0; }
      ableser(z);
    }
    requestAnimationFrame(schritt);
  }

  if (schalter) {
    schalter.addEventListener("click", function () {
      hud.classList.toggle("aus");
      schalter.textContent = hud.classList.contains("aus") ? "Ableser an" : "Ableser aus";
    });
  }

  /* Ein Tab im Hintergrund haelt jedes Video an, der Vorlauf bliebe
     dann auf Bild 1 stehen. Also erst starten, wenn die Seite wirklich
     zu sehen ist, und einen angehaltenen Vorlauf wieder aufnehmen. */
  /* iOS Safari laedt ohne Zutun keine Bilddaten, egal was preload sagt:
     readyState bleibt bei 0 oder 1, loadeddata kommt nie, und der Vorlauf
     stand auf dem iPhone fuer immer auf 'warten', das Feld blieb schwarz.
     Deshalb wird nicht auf loadeddata gewartet, sondern angestossen: nach
     den Metadaten ein stummes play() (muted + playsinline darf das), das
     Safari zum Puffern bringt, sofort wieder pause(), dann los. Schlaegt
     play() fehl (Stromsparmodus), geht es trotzdem los, die Spruenge ueber
     currentTime laden die Bilder dann einzeln nach. Ein Wecker faengt den
     Fall ab, dass keines der Ereignisse kommt. */
  var gestartet = false;
  function anstossen() {
    if (gestartet) return;
    gestartet = true;
    var p;
    try { p = video.play(); } catch (e) { p = null; }
    if (p && typeof p.then === "function") {
      p.then(function () { video.pause(); vorlauf(); }, function () { vorlauf(); });
    } else {
      try { video.pause(); } catch (e) {}
      vorlauf();
    }
  }
  function bereit() {
    if (video.readyState >= 2) { vorlauf(); return; }
    if (video.readyState >= 1) { anstossen(); return; }
    video.addEventListener("loadedmetadata", anstossen, { once: true });
    video.addEventListener("loadeddata", anstossen, { once: true });
    try { video.load(); } catch (e) {}
    setTimeout(anstossen, 2500);
  }

  document.addEventListener("visibilitychange", function () {
    if (phase === "warten") bereit();
  });

  function los() {
    bereit();
    requestAnimationFrame(schritt);
  }

  if (document.readyState === "complete") los();
  else window.addEventListener("load", los);
})();

/* ============================================================
   Der Bildschirm unter dem Zeiger kippt leicht mit.

   Nur der eine, nicht die Reihe: vorher hing die Bewegung am ganzen
   Kasten, dadurch kippten alle vier bei jeder Mausbewegung irgendwo
   darin. Das war unruhig, ohne etwas zu zeigen. Jetzt hoert jede Karte
   fuer sich zu, und wer die Karte verlaesst, laesst sie zurueckgehen.

   Nur wo es passt: kein Geraet ohne echten Zeiger (hover: none), und
   nichts bei prefers-reduced-motion -- dieselbe Ruecksicht wie beim
   Titelvideo.

   Gedreht wird der Rahmen, nicht das Bild: der Schatten haengt am Bild
   und kippt dadurch mit seinem Gegenstand.
   ============================================================ */
(function () {
  "use strict";

  var kasten = document.querySelector(".v-schirme");
  if (!kasten) return;
  if (!window.matchMedia("(hover: hover)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var GRAD = 5;          /* groesster Ausschlag, in Grad */
  var TIEFE = 700;       /* Fluchtpunktabstand in px */

  [].forEach.call(kasten.querySelectorAll(".v-frame"), function (karte) {
    var offen = false, mx = 0, my = 0;

    function zeichnen() {
      offen = false;
      var r = karte.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var dx = (mx - (r.left + r.width / 2)) / (r.width / 2);
      var dy = (my - (r.top + r.height / 2)) / (r.height / 2);
      karte.style.transform =
        "perspective(" + TIEFE + "px) rotateY(" + (dx * GRAD).toFixed(2) +
        "deg) rotateX(" + (-dy * GRAD).toFixed(2) + "deg)";
    }

    karte.addEventListener("mousemove", function (e) {
      mx = e.clientX;
      my = e.clientY;
      if (!offen) { offen = true; requestAnimationFrame(zeichnen); }
    });

    karte.addEventListener("mouseleave", function () {
      karte.style.transform = "";
    });
  });
})();

/* Seitensuche ------------------------------------------------------
   Die Lupe im Kopf klappt ein Feld auf; getippt wird auf DIESER Seite
   gesucht, nicht in Shopifys Suche. Treffer werden im Text als <mark>
   eingefasst, der aktuelle bekommt einen Rahmen und wird in die Mitte
   gescrollt; Enter oder der Pfeil springt zum naechsten. Zugeklappte
   FAQ-Antworten werden fuer einen Treffer geoeffnet. Beim Schliessen
   werden alle Marken wieder entfernt und der Text zusammengefuegt. */
(function () {
  "use strict";
  var auf = document.querySelector("[data-suche-auf]");
  var form = document.querySelector("[data-suche]");
  if (!auf || !form) return;
  var feld = form.querySelector("[data-suche-feld]");
  var stand = form.querySelector("[data-suche-stand]");
  var zu = form.querySelector("[data-suche-zu]");
  var wurzel = document.getElementById("inhalt") || document.body;
  var marken = [];
  var dran = -1;

  function aufraeumen() {
    marken.forEach(function (m) {
      var eltern = m.parentNode;
      if (!eltern) return;
      eltern.replaceChild(document.createTextNode(m.textContent), m);
      eltern.normalize();
    });
    marken = [];
    dran = -1;
  }

  function textknoten() {
    var alle = [];
    var laeufer = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (k) {
        var e = k.parentElement;
        if (!e || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(e.tagName)) return NodeFilter.FILTER_REJECT;
        if (e.closest("[data-suche]")) return NodeFilter.FILTER_REJECT;
        if (!k.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while (laeufer.nextNode()) alle.push(laeufer.currentNode);
    return alle;
  }

  function suchen(frage) {
    aufraeumen();
    frage = frage.trim().toLowerCase();
    if (frage.length < 2) { stand.textContent = ""; return; }
    textknoten().forEach(function (k) {
      var text = k.nodeValue, klein = text.toLowerCase(), von = 0, i;
      var rest = k;
      while ((i = klein.indexOf(frage, von)) !== -1) {
        var treffer = rest.splitText(i - von);
        rest = treffer.splitText(frage.length);
        var m = document.createElement("mark");
        m.className = "v-treffer";
        treffer.parentNode.replaceChild(m, treffer);
        m.appendChild(treffer);
        marken.push(m);
        klein = rest.nodeValue.toLowerCase();
        von = 0;
      }
    });
    if (!marken.length) { stand.textContent = "0"; return; }
    springe(0);
  }

  function springe(i) {
    if (!marken.length) return;
    if (dran >= 0) marken[dran].classList.remove("ist-dran");
    dran = (i + marken.length) % marken.length;
    var m = marken[dran];
    m.classList.add("ist-dran");
    var klapp = m.closest("details");
    if (klapp) klapp.open = true;
    m.scrollIntoView({ block: "center", behavior: "smooth" });
    stand.textContent = (dran + 1) + " / " + marken.length;
  }

  function oeffnen() {
    form.hidden = false;
    auf.setAttribute("aria-expanded", "true");
    feld.focus();
  }
  function schliessen() {
    aufraeumen();
    stand.textContent = "";
    feld.value = "";
    form.hidden = true;
    auf.setAttribute("aria-expanded", "false");
  }

  auf.addEventListener("click", function (e) {
    e.preventDefault();
    if (form.hidden) oeffnen(); else schliessen();
  });
  var takt;
  feld.addEventListener("input", function () {
    clearTimeout(takt);
    takt = setTimeout(function () { suchen(feld.value); }, 160);
  });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (marken.length) springe(dran + 1); else suchen(feld.value);
  });
  zu.addEventListener("click", schliessen);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !form.hidden) schliessen();
  });
})();

/* Newsletter-Popup ---------------------------------------------------
   Oeffnet 1,5 s nach dem Ende des Titelvideos, aber nie ueber dem
   Cookie-Banner oder der offenen Seitensuche, nie in einem Tab im
   Hintergrund. "No thanks" oder Schliessen: 30 Tage Ruhe. Angemeldet:
   nie wieder. Absenden per fetch an Shopifys Newsletter-Formular; will
   Shopify eine Captcha-Pruefung, geht das Formular normal ab. Erfolg:
   Code per /discount/ an der Kasse anlegen und anzeigen. */
(function () {
  "use strict";
  var pop = document.querySelector("[data-pop]");
  if (!pop) return;
  var karte = pop.querySelector(".v-pop__karte");
  var form = pop.querySelector("form");
  var feld = pop.querySelector('input[type="email"]');
  var fehler = pop.querySelector("[data-pop-fehler]");
  var code = pop.getAttribute("data-code") || "";
  var SCHLUESSEL = "vio-pop";
  var RUHE_TAGE = 30;

  function lesen() { try { return JSON.parse(localStorage.getItem(SCHLUESSEL) || "null"); } catch (e) { return null; } }
  function merken(status) { try { localStorage.setItem(SCHLUESSEL, JSON.stringify({ status: status, zeit: Date.now() })); } catch (e) {} }
  function gesperrt() {
    var s = lesen();
    if (!s) return false;
    if (s.status === "abonniert") return true;
    return s.status === "weg" && Date.now() - s.zeit < RUHE_TAGE * 864e5;
  }
  /* Nach einem normalen Absenden (Captcha-Pruefung oder Rueckfall unten) laedt
     Shopify die Seite neu und rendert das Formular mit Erfolgs- oder
     Fehlermarke. Dann gilt die Sperre nicht, das Popup zeigt das Ergebnis. */
  var erfolgVomServer = !!form.querySelector("[data-pop-erfolg]");
  var fehlerVomServer = form.querySelector("[data-pop-serverfehler]");
  if (fehlerVomServer && /taken|already|bereits/i.test(fehlerVomServer.textContent)) { erfolgVomServer = true; fehlerVomServer = null; }
  if (!erfolgVomServer && !fehlerVomServer && gesperrt()) return;

  function sichtbar(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden" && el.getBoundingClientRect().height > 0;
  }
  /* Kein Blick auf document.visibilityState: eingebettete Ansichten melden
     dort dauerhaft "hidden" (siehe Titelvideo oben), das Popup kaeme nie.
     Das Videoende-Signal kommt ohnehin nur aus einem laufenden Tab. */
  function stoert() {
    if (sichtbar(document.getElementById("shopify-pc__banner"))) return true;
    var suche = document.querySelector("[data-suche]");
    return !!(suche && !suche.hidden);
  }

  var offen = false, vorher = null, abonniert = false;
  function oeffnen(trotzSperre) {
    if (offen || (!trotzSperre && gesperrt())) return;
    if (stoert()) { setTimeout(function () { oeffnen(trotzSperre); }, 1000); return; }
    offen = true;
    vorher = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add("v-pop-offen");
    setTimeout(function () {
      pop.classList.add("ist-da");
      var ziel = abonniert ? pop.querySelector('[data-pop-schritt="danke"] .v-pop__knopf') : feld;
      try { ziel.focus({ preventScroll: true }); } catch (e) { ziel.focus(); }
    }, 20);
  }
  function schliessen() {
    if (!offen) return;
    offen = false;
    if (!abonniert) merken("weg");
    pop.classList.remove("ist-da");
    document.documentElement.classList.remove("v-pop-offen");
    setTimeout(function () { if (!offen) pop.hidden = true; }, 260);
    if (vorher && vorher.focus) { try { vorher.focus({ preventScroll: true }); } catch (e) {} }
  }

  [].forEach.call(pop.querySelectorAll("[data-pop-zu]"), function (k) { k.addEventListener("click", schliessen); });
  pop.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { e.preventDefault(); schliessen(); return; }
    if (e.key !== "Tab") return;
    var ziele = [].filter.call(karte.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'), function (x) { return x.offsetParent !== null; });
    if (!ziele.length) return;
    var erstes = ziele[0], letztes = ziele[ziele.length - 1];
    if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
  });

  function danke() {
    abonniert = true;
    merken("abonniert");
    pop.querySelector('[data-pop-schritt="anmelden"]').hidden = true;
    pop.querySelector('[data-pop-schritt="danke"]').hidden = false;
    karte.setAttribute("aria-labelledby", "vio-pop-titel-danke");
    var weiter = pop.querySelector('[data-pop-schritt="danke"] .v-pop__knopf');
    if (weiter) weiter.focus();
  }
  var kopie = pop.querySelector("[data-pop-kopie]");
  if (kopie) kopie.addEventListener("click", function () {
    var fertig = function () { kopie.textContent = "Copied"; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fertig, function () {});
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    fehler.hidden = true;
    if (!feld.checkValidity()) { fehler.hidden = false; feld.focus(); return; }
    var knopf = form.querySelector('button[type="submit"]');
    knopf.disabled = true;
    fetch(form.action, { method: "POST", body: new FormData(form), credentials: "same-origin" })
      .then(function (r) {
        if (/\/challenge/.test(r.url)) { form.submit(); return "captcha"; }
        return r.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var f = doc.getElementById("vio-pop-form");
          var serverFehler = f && f.querySelector("[data-pop-serverfehler]");
          var ok = /customer_posted=true/.test(r.url) || !!(f && f.querySelector("[data-pop-erfolg]"));
          if (!ok && serverFehler && /taken|already|bereits/i.test(serverFehler.textContent)) ok = true;
          if (!ok && serverFehler) { var fehlerObjekt = new Error(serverFehler.textContent.trim()); fehlerObjekt.vomServer = true; throw fehlerObjekt; }
          if (!ok) { form.submit(); return "normal"; }   // unerwartete Antwort: Shopify selbst entscheiden lassen
          return fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" }).catch(function () {}).then(function () { return "ok"; });
        });
      })
      .then(function (ergebnis) { if (ergebnis === "ok") danke(); })
      .catch(function (err) {
        if (err && err.vomServer) { fehler.hidden = false; knopf.disabled = false; feld.focus(); }
        else form.submit();   // Netzfehler oder Blockade: normal absenden, die neue Seite zeigt das Ergebnis
      });
  });

  function nachVideoende() { setTimeout(oeffnen, 1500); }
  if (erfolgVomServer) {
    fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" }).catch(function () {});
    danke();
    oeffnen(true);
    try { var u = new URL(location.href); u.searchParams.delete("customer_posted"); history.replaceState(null, "", u.pathname + u.search); } catch (e) {}
  } else if (fehlerVomServer) {
    fehler.hidden = false;
    oeffnen(true);
  } else if (window.vioTitelvideoEnde) nachVideoende();
  else window.addEventListener("vio:titelvideo-ende", nachVideoende, { once: true });
})();


/* Countdown "Limited Offer" ------------------------------------------
   Zaehlt sekundengenau auf data-countdown herunter (Zeitpunkt mit Zeitzone
   aus snippets/vio-einfuehrung). Bei null verschwinden Streifen,
   Streichpreise und Hinweis; die Preise selbst muessen zu diesem Zeitpunkt
   in Shopify umgestellt sein. */
(function () {
  "use strict";
  var uhren = [].slice.call(document.querySelectorAll("[data-countdown]"));
  if (!uhren.length) return;
  function zwei(n) { return (n < 10 ? "0" : "") + n; }
  function setzen(u, teil, wert) {
    var el = u.querySelector('[data-teil="' + teil + '"]');
    if (el && el.textContent !== wert) el.textContent = wert;
  }
  var abgelaufen = false, uhr = null;
  function takt() {
    var jetzt = Date.now();
    uhren.forEach(function (u) {
      var ende = Date.parse(u.getAttribute("data-countdown"));
      if (isNaN(ende)) return;
      var rest = Math.max(0, Math.floor((ende - jetzt) / 1000));
      setzen(u, "d", String(Math.floor(rest / 86400)));
      setzen(u, "h", zwei(Math.floor((rest % 86400) / 3600)));
      setzen(u, "m", zwei(Math.floor((rest % 3600) / 60)));
      setzen(u, "s", zwei(rest % 60));
      if (rest === 0) abgelaufen = true;
    });
    if (abgelaufen) {
      [].forEach.call(document.querySelectorAll("[data-countdown], [data-einfuehrung]"), function (el) { el.hidden = true; });
      if (uhr) clearInterval(uhr);
    }
  }
  takt();
  if (!abgelaufen) uhr = setInterval(takt, 1000);
})();
